import { GOOGLE_ANALYTIC_TRACKING_ID } from '~/constants/environment'

export const appendGtag = () => {
  if (!GOOGLE_ANALYTIC_TRACKING_ID) return

  const gtagSrc = document.createElement('script')
  gtagSrc.async = true
  gtagSrc.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTIC_TRACKING_ID}`

  window.GOOGLE_ANALYTIC_TRACKING_ID = GOOGLE_ANALYTIC_TRACKING_ID

  const gtagScript = document.createElement('script')
  gtagScript.type = 'text/javascript'
  // gtagScript.text = `
  //   window.dataLayer = window.dataLayer || [];
  //   function gtag(){dataLayer.push(arguments);}
  //   gtag('js', new Date());
  //   gtag('config', '${GOOGLE_ANALYTIC_TRACKING_ID}');
  //   window.gtag = gtag;
  // `
  gtagScript.src = '/gaTagLoader.js'

  document.head.appendChild(gtagSrc)
  document.head.appendChild(gtagScript)
}
